import { Injectable } from '@angular/core';
import { L10n, loadCldr } from '@syncfusion/ej2-base';

import caCs from 'cldr-data/main/cs/ca-gregorian.json';
import numbersCs from 'cldr-data/main/cs/numbers.json';
import dateFieldsCs from 'cldr-data/main/cs/dateFields.json';
import timezoneNamesCs from 'cldr-data/main/cs/timeZoneNames.json';
import numberingSystemsLatn from 'cldr-data/supplemental/numberingSystems.json';

import caSk from 'cldr-data/main/sk/ca-gregorian.json';
import numbersSk from 'cldr-data/main/sk/numbers.json';
import dateFieldsSk from 'cldr-data/main/sk/dateFields.json';
import timezoneNamesSk from 'cldr-data/main/sk/timeZoneNames.json';

loadCldr(caCs, numbersCs, timezoneNamesCs, numberingSystemsLatn, dateFieldsCs);
loadCldr(caSk, numbersSk, timezoneNamesSk, numberingSystemsLatn, dateFieldsSk);
L10n.load({
  "en": {
    "schedule": {
      "day": "Day",
      "week": "Week",
      "workWeek": "Work Week",
      "month": "Month",
      "year": "Year",
      "agenda": "Agenda",
      "weekAgenda": "Week Agenda",
      "workWeekAgenda": "Work Week Agenda",
      "monthAgenda": "Month Agenda",
      "today": "Today",
      "noEvents": "No events",
      "emptyContainer": "There are no events scheduled on this day.",
      "allDay": "All day",
      "start": "Start",
      "end": "End",
      "more": "more",
      "close": "Close",
      "cancel": "Cancel",
      "noTitle": "(No Title)",
      "delete": "Delete",
      "deleteEvent": "This Event",
      "deleteMultipleEvent": "Delete Multiple Events",
      "selectedItems": "Items selected",
      "deleteSeries": "Entire Series",
      "edit": "Edit",
      "editSeries": "Entire Series",
      "editEvent": "This Event",
      "createEvent": "Create",
      "subject": "Subject",
      "addTitle": "Add title",
      "moreDetails": "More Details",
      "save": "Save",
      "editContent": "How would you like to change the appointment in the series?",
      "deleteContent": "Are you sure you want to delete this event?",
      "deleteMultipleContent": "Are you sure you want to delete the selected events?",
      "newEvent": "New Event",
      "title": "Title",
      "location": "Location",
      "description": "Description",
      "timezone": "Timezone",
      "startTimezone": "Start Timezone",
      "endTimezone": "End Timezone",
      "repeat": "Repeat",
      "saveButton": "Save",
      "cancelButton": "Cancel",
      "deleteButton": "Delete",
      "recurrence": "Recurrence",
      "wrongPattern": "The recurrence pattern is not valid.",
      "seriesChangeAlert": "Do you want to cancel the changes made to specific instances of this series and match it to the whole series again?",
      "createError": "The duration of the event must be shorter than how frequently it occurs. Shorten the duration, or change the recurrence pattern in the recurrence event editor.",
      "sameDayAlert": "Two occurrences of the same event cannot occur on the same day.",
      "editRecurrence": "Edit Recurrence",
      "repeats": "Repeats",
      "alert": "Alert",
      "startEndError": "The selected end date occurs before the start date.",
      "invalidDateError": "The entered date value is invalid.",
      "blockAlert": "Events cannot be scheduled within the blocked time range.",
      "ok": "Ok",
      "yes": "Yes",
      "no": "No",
      "occurrence": "Occurrence",
      "series": "Series",
      "previous": "Previous",
      "next": "Next",
      "timelineDay": "Timeline Day",
      "timelineWeek": "Timeline Week",
      "timelineWorkWeek": "Timeline Work Week",
      "timelineMonth": "Timeline Month",
      "timelineYear": "Timeline Year",
      "editFollowingEvent": "Following Events",
      "deleteTitle": "Delete Event",
      "editTitle": "Edit Event",
      "beginFrom": "Begin From",
      "endAt": "End At",
      "expandAllDaySection": "Expand-all-day-section",
      "collapseAllDaySection": "Collapse-all-day-section"
    },
    "recurrenceeditor": {
      "none": "None",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "month": "Month",
      "yearly": "Yearly",
      "never": "Never",
      "until": "Until",
      "count": "Count",
      "first": "First",
      "second": "Second",
      "third": "Third",
      "fourth": "Fourth",
      "last": "Last",
      "repeat": "Repeat",
      "repeatEvery": "Repeat every",
      "on": "Repeat On",
      "end": "End",
      "onDay": "Day",
      "days": "Day(s)",
      "weeks": "Week(s)",
      "months": "Month(s)",
      "years": "Year(s)",
      "every": "every",
      "summaryTimes": "time(s)",
      "summaryOn": "on",
      "summaryUntil": "until",
      "summaryRepeat": "Repeats",
      "summaryDay": "day(s)",
      "summaryWeek": "week(s)",
      "summaryMonth": "month(s)",
      "summaryYear": "year(s)",
      "monthWeek": "Month Week",
      "monthPosition": "Month Position",
      "monthExpander": "Month Expander",
      "yearExpander": "Year Expander",
      "repeatInterval": "Repeat Interval"
    }
  },
  "cs": {
    "schedule": {
      "day": "Den",
      "week": "Týden",
      "workWeek": "Pracovní týden",
      "month": "Měsíc",
      "year": "Rok",
      "agenda": "Agenda",
      "weekAgenda": "Týdenní agenda",
      "workWeekAgenda": "Agenda pracovního týdne",
      "monthAgenda": "Měsíční agenda",
      "today": "Dnes",
      "noEvents": "Žádné události",
      "emptyContainer": "Na tento den nejsou naplánovány žádné události.",
      "allDay": "Celý den",
      "start": "Začátek",
      "end": "Konec",
      "more": "více",
      "close": "Zavřít",
      "cancel": "Zrušit",
      "noTitle": "(Bez názvu)",
      "delete": "Smazat",
      "deleteEvent": "Tato událost",
      "deleteMultipleEvent": "Smazat více událostí",
      "selectedItems": "Vybrané položky",
      "deleteSeries": "Celá série",
      "edit": "Upravit",
      "editSeries": "Celá série",
      "editEvent": "Tato událost",
      "createEvent": "Vytvořit",
      "subject": "Předmět",
      "addTitle": "Přidat název",
      "moreDetails": "Více podrobností",
      "save": "Uložit",
      "editContent": "Jak byste chtěli změnit schůzku v sérii?",
      "deleteContent": "Opravdu chcete smazat tuto událost?",
      "deleteMultipleContent": "Opravdu chcete smazat vybrané události?",
      "newEvent": "Nová událost",
      "title": "Název",
      "location": "Místo",
      "description": "Popis",
      "timezone": "Časové pásmo",
      "startTimezone": "Časové pásmo začátku",
      "endTimezone": "Časové pásmo konce",
      "repeat": "Opakovat",
      "saveButton": "Uložit",
      "cancelButton": "Zrušit",
      "deleteButton": "Smazat",
      "recurrence": "Opakování",
      "wrongPattern": "Vzorec opakování není platný.",
      "seriesChangeAlert": "Chcete zrušit změny provedené v konkrétních případech této série a sladit je s celou sérií znovu?",
      "createError": "Délka události musí být kratší než frekvence jejího výskytu. Zkraťte dobu trvání nebo změňte vzorec opakování v editoru opakovaných událostí.",
      "sameDayAlert": "Dvě události stejné události nemohou nastat ve stejný den.",
      "editRecurrence": "Upravit opakování",
      "repeats": "Opakuje se",
      "alert": "Upozornění",
      "startEndError": "Vybraný konečný datum je před počátečním datem.",
      "invalidDateError": "Zadaná hodnota data je neplatná.",
      "blockAlert": "Události nelze plánovat v blokovaném časovém rozmezí.",
      "ok": "Ok",
      "yes": "Ano",
      "no": "Ne",
      "occurrence": "Výskyt",
      "series": "Série",
      "previous": "Předchozí",
      "next": "Další",
      "timelineDay": "Časová osa dne",
      "timelineWeek": "Časová osa týdne",
      "timelineWorkWeek": "Časová osa pracovního týdne",
      "timelineMonth": "Časová osa měsíce",
      "timelineYear": "Časová osa roku",
      "editFollowingEvent": "Následující události",
      "deleteTitle": "Smazat událost",
      "editTitle": "Upravit událost",
      "beginFrom": "Začít od",
      "endAt": "Konec v",
      "expandAllDaySection": "Rozbalit celodenní sekci",
      "collapseAllDaySection": "Sbalit celodenní sekci"
    },
    "recurrenceeditor": {
      "none": "Žádné",
      "daily": "Denně",
      "weekly": "Týdně",
      "monthly": "Měsíčně",
      "month": "Měsíc",
      "yearly": "Ročně",
      "never": "Nikdy",
      "until": "Do",
      "count": "Počet",
      "first": "První",
      "second": "Druhý",
      "third": "Třetí",
      "fourth": "Čtvrtý",
      "last": "Poslední",
      "repeat": "Opakovat",
      "repeatEvery": "Opakovat každý",
      "on": "Opakovat v",
      "end": "Konec",
      "onDay": "Den",
      "days": "Den (dny)",
      "weeks": "Týden (týdny)",
      "months": "Měsíc (měsíce)",
      "years": "Rok (roky)",
      "every": "každý",
      "summaryTimes": "čas(y)",
      "summaryOn": "v",
      "summaryUntil": "do",
      "summaryRepeat": "Opakuje se",
      "summaryDay": "den (dny)",
      "summaryWeek": "týden (týdny)",
      "summaryMonth": "měsíc (měsíce)",
      "summaryYear": "rok (roky)",
      "monthWeek": "Týden měsíce",
      "monthPosition": "Pozice měsíce",
      "monthExpander": "Rozšíření měsíce",
      "yearExpander": "Rozšíření roku",
      "repeatInterval": "Interval opakování"
    }
  },
  "sk": {
    "schedule": {
      "day": "Den",
      "week": "Týden",
      "workWeek": "Pracovní týden",
      "month": "Měsíc",
      "year": "Rok",
      "agenda": "Agenda",
      "weekAgenda": "Týdenní agenda",
      "workWeekAgenda": "Agenda pracovního týdne",
      "monthAgenda": "Měsíční agenda",
      "today": "Dnes",
      "noEvents": "Žádné události",
      "emptyContainer": "Na tento den nejsou naplánovány žádné události.",
      "allDay": "Celý den",
      "start": "Začátek",
      "end": "Konec",
      "more": "více",
      "close": "Zavřít",
      "cancel": "Zrušit",
      "noTitle": "(Bez názvu)",
      "delete": "Smazat",
      "deleteEvent": "Tato událost",
      "deleteMultipleEvent": "Smazat více událostí",
      "selectedItems": "Vybrané položky",
      "deleteSeries": "Celá série",
      "edit": "Upravit",
      "editSeries": "Celá série",
      "editEvent": "Tato událost",
      "createEvent": "Vytvořit",
      "subject": "Předmět",
      "addTitle": "Přidat název",
      "moreDetails": "Více podrobností",
      "save": "Uložit",
      "editContent": "Jak byste chtěli změnit schůzku v sérii?",
      "deleteContent": "Opravdu chcete smazat tuto událost?",
      "deleteMultipleContent": "Opravdu chcete smazat vybrané události?",
      "newEvent": "Nová událost",
      "title": "Název",
      "location": "Místo",
      "description": "Popis",
      "timezone": "Časové pásmo",
      "startTimezone": "Časové pásmo začátku",
      "endTimezone": "Časové pásmo konce",
      "repeat": "Opakovat",
      "saveButton": "Uložit",
      "cancelButton": "Zrušit",
      "deleteButton": "Smazat",
      "recurrence": "Opakování",
      "wrongPattern": "Vzorec opakování není platný.",
      "seriesChangeAlert": "Chcete zrušit změny provedené v konkrétních případech této série a sladit je s celou sérií znovu?",
      "createError": "Délka události musí být kratší než frekvence jejího výskytu. Zkraťte dobu trvání nebo změňte vzorec opakování v editoru opakovaných událostí.",
      "sameDayAlert": "Dvě události stejné události nemohou nastat ve stejný den.",
      "editRecurrence": "Upravit opakování",
      "repeats": "Opakuje se",
      "alert": "Upozornění",
      "startEndError": "Vybraný konečný datum je před počátečním datem.",
      "invalidDateError": "Zadaná hodnota data je neplatná.",
      "blockAlert": "Události nelze plánovat v blokovaném časovém rozmezí.",
      "ok": "Ok",
      "yes": "Ano",
      "no": "Ne",
      "occurrence": "Výskyt",
      "series": "Série",
      "previous": "Předchozí",
      "next": "Další",
      "timelineDay": "Časová osa dne",
      "timelineWeek": "Časová osa týdne",
      "timelineWorkWeek": "Časová osa pracovního týdne",
      "timelineMonth": "Časová osa měsíce",
      "timelineYear": "Časová osa roku",
      "editFollowingEvent": "Následující události",
      "deleteTitle": "Smazat událost",
      "editTitle": "Upravit událost",
      "beginFrom": "Začít od",
      "endAt": "Konec v",
      "expandAllDaySection": "Rozbalit celodenní sekci",
      "collapseAllDaySection": "Sbalit celodenní sekci"
    },
    "recurrenceeditor": {
      "none": "Žádné",
      "daily": "Denně",
      "weekly": "Týdně",
      "monthly": "Měsíčně",
      "month": "Měsíc",
      "yearly": "Ročně",
      "never": "Nikdy",
      "until": "Do",
      "count": "Počet",
      "first": "První",
      "second": "Druhý",
      "third": "Třetí",
      "fourth": "Čtvrtý",
      "last": "Poslední",
      "repeat": "Opakovat",
      "repeatEvery": "Opakovat každý",
      "on": "Opakovat v",
      "end": "Konec",
      "onDay": "Den",
      "days": "Den (dny)",
      "weeks": "Týden (týdny)",
      "months": "Měsíc (měsíce)",
      "years": "Rok (roky)",
      "every": "každý",
      "summaryTimes": "čas(y)",
      "summaryOn": "v",
      "summaryUntil": "do",
      "summaryRepeat": "Opakuje se",
      "summaryDay": "den (dny)",
      "summaryWeek": "týden (týdny)",
      "summaryMonth": "měsíc (měsíce)",
      "summaryYear": "rok (roky)",
      "monthWeek": "Týden měsíce",
      "monthPosition": "Pozice měsíce",
      "monthExpander": "Rozšíření měsíce",
      "yearExpander": "Rozšíření roku",
      "repeatInterval": "Interval opakování"
    }
  },
});

@Injectable({
  providedIn: 'root'
})
export class SchedulerLocalizeService {

  constructor() { }
}
